import { defineStore } from 'pinia'
import { ref } from 'vue'
import { HomeAPI } from '@/services/home'
import { BackpackAPI } from '@/services/backpack'

export const useMineStore = defineStore('mine', () => {
  // Like 数据
  const likeList = ref<any[]>([])
  const likeLoading = ref(false)
  const likeInitialized = ref(false)
  const likeError = ref<string | null>(null) // 🔧 新增：错误状态

  // Backpack 数据
  const backpackList = ref<any[]>([])
  const backpackLoading = ref(false)
  const backpackInitialized = ref(false)
  const backpackError = ref<string | null>(null) // 🔧 新增：错误状态

  /**
   * 获取 Like 列表
   */
  const fetchLikeList = async () => {
    try {
      likeLoading.value = true
      likeError.value = null // 🔧 清除之前的错误
      const res = await HomeAPI.getDialogueList({ type: 1 })
      likeList.value = res?.data || []
      likeInitialized.value = true
      likeError.value = null // 🔧 成功时清除错误
      return likeList.value
    } catch (error: any) {
      console.error('获取 Like 列表失败:', error)
      likeError.value = error?.message || 'Failed to load like list' // 🔧 保存错误信息
      throw error
    } finally {
      likeLoading.value = false
    }
  }

  /**
   * 刷新 Like 列表
   */
  const refreshLikeList = async () => {
    try {
      likeError.value = null // 🔧 清除之前的错误
      const res = await HomeAPI.getDialogueList({ type: 1 })
      likeList.value = res?.data || []
      likeInitialized.value = true
      likeError.value = null // 🔧 成功时清除错误
      return likeList.value
    } catch (error: any) {
      console.error('刷新 Like 列表失败:', error)
      likeError.value = error?.message || 'Failed to refresh like list' // 🔧 保存错误信息
      throw error
    }
  }

  /**
   * 获取 Backpack 列表
   */
  const fetchBackpackList = async () => {
    try {
      backpackLoading.value = true
      backpackError.value = null // 🔧 清除之前的错误
      const res = await BackpackAPI.getBackpackList({
        page: 1,
        pageSize: 100
      })
      backpackList.value = res?.data || []
      backpackInitialized.value = true
      backpackError.value = null // 🔧 成功时清除错误
      return backpackList.value
    } catch (error: any) {
      console.error('获取 Backpack 列表失败:', error)
      backpackError.value = error?.message || 'Failed to load backpack list' // 🔧 保存错误信息
      throw error
    } finally {
      backpackLoading.value = false
    }
  }

  /**
   * 刷新 Backpack 列表
   */
  const refreshBackpackList = async () => {
    try {
      backpackError.value = null // 🔧 清除之前的错误
      const res = await BackpackAPI.getBackpackList({
        page: 1,
        pageSize: 100
      })
      backpackList.value = res?.data || []
      backpackInitialized.value = true
      backpackError.value = null // 🔧 成功时清除错误
      return backpackList.value
    } catch (error: any) {
      console.error('刷新 Backpack 列表失败:', error)
      backpackError.value = error?.message || 'Failed to refresh backpack list' // 🔧 保存错误信息
      throw error
    }
  }

  /**
   * 清空所有数据（用于退出登录等场景）
   */
  const clearAllData = () => {
    likeList.value = []
    likeLoading.value = false
    likeInitialized.value = false
    backpackList.value = []
    backpackLoading.value = false
    backpackInitialized.value = false
  }

  return {
    // Like state
    likeList,
    likeLoading,
    likeInitialized,
    likeError, // 🔧 新增：错误状态
    // Backpack state
    backpackList,
    backpackLoading,
    backpackInitialized,
    backpackError, // 🔧 新增：错误状态
    // Actions
    fetchLikeList,
    refreshLikeList,
    fetchBackpackList,
    refreshBackpackList,
    clearAllData
  }
})

